import styled from 'styled-components';
import { isEmpty } from '@iterable/utils';
import { QueryParamErrors } from '../types';

type UrlFilterErrorToastProps = {
  errors: QueryParamErrors;
};

export const UrlFilterErrorToast = ({ errors }: UrlFilterErrorToastProps) => {
  const { invalidParamList, invalidValsByParam } = errors;

  const Item = styled.li`
    display: list-item;
    list-style-type: disc;
  `;

  return (
    <div>
      {invalidParamList.length > 0 && (
        <>
          <div>Invalid url parameters:</div>
          <ul>
            {invalidParamList.map((e, i) => (
              <Item key={i}>{e}</Item>
            ))}
          </ul>
        </>
      )}
      {!isEmpty(invalidValsByParam) && (
        <>
          <div>Invalid url values:</div>
          {Object.entries(invalidValsByParam).map(([param, val], i) => (
            <div key={i}>
              <div>{param}</div>
              <ul>
                {val.map((v, ind) => (
                  <Item key={ind}>{v}</Item>
                ))}
              </ul>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
